// Phase model for the in-treatment session flow.
//
// Iter AU — Reassess pain BEFORE findings/recommendations so the ending pain
// score is already captured when the AI writes the summary (no more
// "refresh recommendations" loop):
//   PRE-TREATMENT  (linear): setup → length → complaint → photos → pain → rom
//   TREATMENT     (free tabs): diagram / notes / capture
//   REASSESS & FINDINGS (linear, client still on table): pain reassess → rom reassess → findings → recommendations
//   WRAP-UP (linear, optional after client dresses): movement photos → save

export const PRE_STEPS = ["pre-setup", "pre-changes", "pre-length", "pre-complaint", "pre-photos", "pre-rom"];
export const TX_STEPS = ["tx-diagram", "tx-notes", "tx-capture"];
export const EOT_STEPS = ["post-pain", "post-rom", "eot-findings", "eot-recs"];
export const POST_STEPS = ["post-photos", "post-save"];
export const ALL_STEPS = [...PRE_STEPS, ...TX_STEPS, ...EOT_STEPS, ...POST_STEPS];

export const SUPER_FOR = (phase) => {
  if (PRE_STEPS.includes(phase)) return "pre";
  if (TX_STEPS.includes(phase)) return "tx";
  if (EOT_STEPS.includes(phase)) return "eot";
  if (POST_STEPS.includes(phase)) return "post";
  return "pre";
};

export const PRE_LABELS = {
  "pre-setup": "Setup",
  "pre-changes": "What changed?",
  "pre-length": "Session length",
  "pre-complaint": "Chief complaint",
  "pre-photos": "Photos & intake",
  "pre-rom": "Baseline ROM",
};
export const TX_LABELS = {
  "tx-diagram": "Diagram",
  "tx-notes": "Notes",
  "tx-capture": "Capture",
};
export const EOT_LABELS = {
  "post-pain": "Pain reassessment",
  "post-rom": "ROM reassessment",
  "eot-findings": "Clinical findings",
  "eot-recs": "Recommendations",
};
export const POST_LABELS = {
  "post-photos": "Movement photos",
  "post-save": "Save",
};
